import React from 'react';
import { Info } from 'react-feather';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const ContentItemError = ({ message }) => {
  const errorMessage =
    message || t('in_person_training.errors.associated_content_removal_failed');
  return (
    <div className="d-f fd-r ai-fs mt-8">
      <Info className="mr-8 llui-text-instrux-error" size={17} />
      <Text variant={TEXT_VARIANTS.INSTRUX_ERROR}>{errorMessage}</Text>
    </div>
  );
};

export default ContentItemError;
